export const dashboardEndpointConfig = {
  baseUrlV1: "api/v1",
  baseUrlV2: "api/v2",
  plusDashboardData: (): string =>
    `${dashboardEndpointConfig.baseUrlV1}/plus-dashboards`,
  dashboardData: (): string =>
    `${dashboardEndpointConfig.baseUrlV1}/dashboards`,
  dashboardTimeBase: (): string =>
    `${dashboardEndpointConfig.baseUrlV2}/dashboards/volumes/timebase`,
  plusDashboardTimeBase: (): string =>
    `${dashboardEndpointConfig.baseUrlV2}/dashboards/volumes/timebase`,
  plusDashboardGlobal: (): string =>
    `${dashboardEndpointConfig.baseUrlV2}/dashboards/volumes/plus-global`,
  dashboardGlobal: (): string =>
    `${dashboardEndpointConfig.baseUrlV2}/dashboards/volumes/global`,
  dashboardStationsV1: (): string =>
    `${dashboardEndpointConfig.baseUrlV1}/dashboards/stations`,
  dashboardStationsV2: (): string =>
    `${dashboardEndpointConfig.baseUrlV2}/dashboards/stations/volumes`,
};
